import React from "react";
import { Box, Container, Grid, IconButton, Tooltip } from "@mui/material";
import { useAuth } from "../../Providers/AuthProvider";
import { AccountProfile } from "../../components/account/AccountProfile";
import CreateApikeyComp from "../../components/account/CreateApiKeyComp";
import { AccountProfileDetails } from "../../components/account/AccountProfileDetails";
import ChangePassComp from "../../components/account/ChangePassComp";
import { NavBar } from "../../components/NavBar";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import WrapperComp from "../../components/WrapperComp";
import { ErrorBoundary } from "../../components/ErrorBoundary";

function Account() {
  const userDetails = JSON.parse(sessionStorage.getItem("userInfo")) || {};
  const { refreshUserInfo, userInfo } = useAuth();
  const navigate = useNavigate();

  const refetch = async () => {
    const res = await refreshUserInfo(userDetails?.userid, userDetails?.apikey);
    return res;
  };

  return (
    <ErrorBoundary>
      <WrapperComp>
        <div
          key={userInfo?.userid}
          style={{
            marginBottom: 50,
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div
            style={{
              flex: 1,
              width: "100%",
            }}
          >
            <Container maxWidth="xl">
              <Box
                component="main"
                sx={{
                  flexGrow: 1,
                  px: 2,
                }}
              >
                <div className="pt-6 pb-2">
                  <Tooltip title="Go Back">
                    <IconButton onClick={() => navigate(-1)}>
                      <ArrowBack />
                    </IconButton>
                  </Tooltip>
                </div>

                <Grid container spacing={2} alignItems={"stretch"}>
                  <AccountProfile />

                  <Grid item lg={6} md={12} xs={12}>
                    <CreateApikeyComp
                      onSuccess={refetch}
                      useridvalue={userDetails?.userid}
                    />
                  </Grid>

                  <Grid item lg={6} md={12} xs={12}>
                    <AccountProfileDetails refresh={refetch} />
                  </Grid>

                  <Grid item lg={6} md={12} xs={12}>
                    <ChangePassComp
                      userInfo={userDetails}
                      useridvalue={userDetails?.userid}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Container>
          </div>
        </div>
      </WrapperComp>
    </ErrorBoundary>
  );
}

export default Account;
